import React, { useEffect, useState } from "react";
import "./Settings.css";
import "../Inventory/Inventory.css";
import { FiEdit } from "react-icons/fi";

import profile from "../../../assets/images/previewPlaceholder.png";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosInstance } from "../../../axiosInstance";
import * as yup from "yup";

let profileSchema = yup.object({
  profile: yup
    .mixed()
    // .required("Product image is required")
    .nullable()
    .test("fileType", "Only PNG, JPG, and JPEG images are allowed", (file) => {
      if (!file) return true; // allow null / unchanged image
      if (typeof file === "string") return true; // existing image URL allowed
      return ["image/png", "image/jpg", "image/jpeg"].includes(file.type);
    }),
  phone_number: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
});

export const Settings = () => {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      profile: null,
      // username: "tradevibeglobal",
      // first_name: "",
      // last_name: "",
      // email: "info@tradevibeglobal.in",
      email: "",
      phone_number: "",
      hno: "",
      street: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      state_code: "",
      // user_type: "DISTRIBUTOR",
      gstin: "",
      pan: "",
      account_holder_name: "",
      bank_name: "",
      account_number: "",
      ifsc_code: "",
      branch_name: "",
      phone_pay_number: "",
      google_pay_number: "",
      qr_code: null,
      terms_and_conditions: "",

      distributor_name: "",
      company_logo: null,
    },
    validationSchema: profileSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const formData = new FormData();
        // user object

        if (values.profile instanceof File) {
          formData.append("user.profile", values.profile);
        }

        // formData.append("user.username", values.username);
        // formData.append("user.first_name", values.first_name);
        // formData.append("user.last_name", values.last_name);
        // formData.append("user.email", values.email);
        formData.append("user.phone_number", values.phone_number);
        formData.append("user.hno", values.hno);
        formData.append("user.street", values.street);
        formData.append("user.city", values.city);
        formData.append("user.district", values.district);
        formData.append("user.state", values.state);
        formData.append("user.state_code", values.state_code);
        formData.append("user.pincode", values.pincode);
        // formData.append("user.user_type", values.user_type);
        formData.append("user.gstin", values.gstin);
        formData.append("user.pan", values.pan);
        formData.append("user.account_holder_name", values.account_holder_name);
        formData.append("user.bank_name", values.bank_name);
        formData.append("user.account_number", values.account_number);
        formData.append("user.ifsc_code", values.ifsc_code);
        formData.append("user.branch_name", values.branch_name);
        formData.append("user.phone_pay_number", values.phone_pay_number);
        formData.append("user.google_pay_number", values.google_pay_number);
        formData.append(
          "user.terms_and_conditions",
          values.terms_and_conditions,
        );
        if (values.qr_code instanceof File) {
          formData.append("user.qr_code", values.qr_code);
        }

        // out side user object
        formData.append("distributor_name", values.distributor_name);
        if (values.company_logo instanceof File) {
          formData.append("company_logo", values.company_logo);
        }

        const response = await axiosInstance.put("/user-details", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.status === "success" || response.status === 200) {
          LoadProfile();

          toast.success(
            response.data.message || "Profile updated successfully",
          );
          console.log(response.data.message || "Profile updated successfully");
        }
      } catch (error) {
        toast.error(error.response.data.message || "Failed to update profile");
        console.log(error.response.data.message || "Failed to update profile");
      } finally {
        setLoading(false);
      }
    },
  });
  async function LoadProfile() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/user-details");
      if (response.data.status === "success" || response.status === 200) {
        const res = response.data.data;
        const user = res.user;

        formik.setValues({
          profile: user.profile || "",
          username: user.username || "",
          // first_name: user.first_name || "",
          // last_name: user.last_name || "",
          email: user.email || "",
          phone_number: user.phone_number || "",
          hno: user.hno || "",
          street: user.street || "",
          city: user.city || "",
          district: user.district || "",
          state: user.state || "",
          state_code: user.state_code || "",
          pincode: user.pincode || "",
          // user_type: "DISTRIBUTOR",
          gstin: user.gstin || "",
          pan: user.pan || "",
          account_holder_name: user.account_holder_name || "",
          bank_name: user.bank_name || "",
          account_number: user.account_number || "",
          ifsc_code: user.ifsc_code || "",
          branch_name: user.branch_name || "",
          phone_pay_number: user.phone_pay_number || "",
          google_pay_number: user.google_pay_number || "",
          qr_code: user.qr_code || "",
          terms_and_conditions: user.terms_and_conditions || "",

          distributor_name: res.distributor_name || "",
          company_logo: res.company_logo || "",
        });
      }
    } catch (error) {
      console.log("Failed to fetch profile data");
      toast.error(
        error.response.data.message || "Failed to fetch profile data",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    LoadProfile();
  }, []);
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="ordersContainer">
        <div className="container">
          <div className="inventoryTitle">Settings</div>
          <div className="inventorySubtitle">
            Manage your account, distributors, and system preferences.
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="settingsContainer">
              <div>
                <div className="settingsProfileImg">
                  <img
                    src={
                      formik.values.profile
                        ? typeof formik.values.profile === "object"
                          ? URL.createObjectURL(formik.values.profile) // File object
                          : formik.values.profile // URL string from API
                        : profile // default placeholder
                    }
                  />
                </div>
                <div className="profileEditText">
                  <label htmlFor="edit">
                    <span className="me-1">
                      <FiEdit />
                    </span>
                    Change Picture
                  </label>
                  <div style={{ display: "none" }}>
                    <input
                      type="file"
                      id="edit"
                      name="profile"
                      onChange={(e) => {
                        formik.setFieldValue(
                          "profile",
                          e.currentTarget.files[0],
                        );
                      }}
                    />
                  </div>
                </div>
                {formik.errors.profile && formik.touched.profile && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {formik.errors.profile}
                  </div>
                )}
              </div>
              {/* profile settins  */}
              <div className="settingsTitle">Profile Settings</div>
              <div className="settingsInputGrid">
                <div className="settingsInput">
                  <label>Distributor Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Distributor Name"
                      name="distributor_name"
                      onChange={formik.handleChange}
                      value={formik.values.distributor_name}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Phone Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Phone Number"
                      name="phone_number"
                      onChange={formik.handleChange}
                      value={formik.values.phone_number}
                    />
                    {formik.errors.phone_number &&
                      formik.touched.phone_number && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.phone_number}
                        </div>
                      )}
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Email</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Email"
                      name="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      // value={"info@tradevibeglobal.in"}
                      disabled
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>GSTIN</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter GSTIN"
                      name="gstin"
                      onChange={formik.handleChange}
                      value={formik.values.gstin}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>PAN Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter PAN"
                      name="pan"
                      onChange={formik.handleChange}
                      value={formik.values.pan}
                    />
                  </div>
                </div>
              </div>
              <div className="settingsInput mt-3">
                <label>Company Logo</label>
                <div>
                  <input
                    type="file"
                    name="company_logo"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "company_logo",
                        e.currentTarget.files[0],
                      );
                    }}
                  />
                </div>
                <div className="settingsProfileImg mt-2">
                  <img
                    src={
                      formik.values.company_logo
                        ? typeof formik.values.company_logo === "object"
                          ? URL.createObjectURL(formik.values.company_logo) // File object
                          : formik.values.company_logo // URL string from API
                        : profile // default placeholder
                    }
                  />
                </div>
              </div>

              {/* address  */}
              <div className="settingsTitle">Address</div>
              <div className="settingsInputGrid">
                <div className="settingsInput">
                  <label>H.No</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter H.No"
                      name="hno"
                      onChange={formik.handleChange}
                      value={formik.values.hno}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Street</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Street"
                      name="street"
                      onChange={formik.handleChange}
                      value={formik.values.street}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>City</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter City"
                      name="city"
                      onChange={formik.handleChange}
                      value={formik.values.city}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>District</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter District"
                      name="district"
                      onChange={formik.handleChange}
                      value={formik.values.district}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>State</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      onChange={formik.handleChange}
                      value={formik.values.state}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>State Code</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter State Code"
                      name="state_code"
                      onChange={formik.handleChange}
                      value={formik.values.state_code}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Pincode</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Pincode"
                      name="pincode"
                      onChange={formik.handleChange}
                      value={formik.values.pincode}
                    />
                  </div>
                </div>
              </div>

              {/* preferences */}
              <div className="settingsTitle">Preferences</div>
              {/* <div className="settingsInputGrid">
                <div className="settingsInput">
                  <label>Currency</label>
                  <div>
                    <select>
                      <option>INR</option>
                    </select>
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Date Format</label>
                  <div>
                    <input type="date" />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Language</label>
                  <div>
                    <input type="text" placeholder="Enter Language" />
                  </div>
                </div>
                <div className="settingsInput">
                  <FormGroup>
                    <FormControlLabel
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          color: "#414652",
                          fontSize: "14px",
                          fontWeight: 600,
                          fontFamily: "var(--font-family)",
                          fontOpticalSizing: "var(--font-optical-sizing)",
                          fontStyle: "var(--font-style)",
                        },
                      }}
                      control={<Switch />}
                      label="Notifications"
                    />
                  </FormGroup>
                </div>
              </div> */}
              <div className="settingsInputGrid">
                <div className="settingsInput">
                  <label>Account Holder Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Account Holder Name"
                      name="account_holder_name"
                      onChange={formik.handleChange}
                      value={formik.values.account_holder_name}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Bank Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Bank Name"
                      name="bank_name"
                      onChange={formik.handleChange}
                      value={formik.values.bank_name}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Account Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Account Number"
                      name="account_number"
                      onChange={formik.handleChange}
                      value={formik.values.account_number}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>IFSC Code</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter IFSC Code"
                      name="ifsc_code"
                      onChange={formik.handleChange}
                      value={formik.values.ifsc_code}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Branch Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Branch Name"
                      name="branch_name"
                      onChange={formik.handleChange}
                      value={formik.values.branch_name}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Phone Pay Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Phone Pay Number"
                      name="phone_pay_number"
                      onChange={formik.handleChange}
                      value={formik.values.phone_pay_number}
                    />
                  </div>
                </div>
                <div className="settingsInput">
                  <label>Google Pay Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Google Pay Number"
                      name="google_pay_number"
                      onChange={formik.handleChange}
                      value={formik.values.google_pay_number}
                    />
                  </div>
                </div>
              </div>
              <div className="settingsInput mt-3">
                <label>QR Code</label>
                <div>
                  <input
                    type="file"
                    name="qr_code"
                    onChange={(e) => {
                      formik.setFieldValue("qr_code", e.currentTarget.files[0]);
                    }}
                  />
                </div>
                <div className="settingsProfileImg mt-2">
                  <img
                    src={
                      formik.values.qr_code
                        ? typeof formik.values.qr_code === "object"
                          ? URL.createObjectURL(formik.values.qr_code) // File object
                          : formik.values.qr_code // URL string from API
                        : profile // default placeholder
                    }
                  />
                </div>
              </div>

              <div className="settingsInput mt-2">
                <label>Terms & Conditions</label>
                <div>
                  <textarea
                    rows={4}
                    placeholder="Type here..."
                    value={formik.values.terms_and_conditions}
                    name="terms_and_conditions"
                    onChange={formik.handleChange}
                  ></textarea>
                </div>
              </div>

              {/* buttons  */}
              <div className="settingsBtnContainer">
                <div className="settingsBtn">
                  {/* <button>Cancel</button> */}
                  {/* <div>{""}</div> */}
                  <button type="submit">Save Changes</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
